import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "10",
      cy: "10",
      r: "3.6",
      stroke: "currentColor",
      "stroke-width": "1.6"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "1.6",
      d: "M10 1.8v2m0 12.4v2M1.8 10h2m12.4 0h2m-14-5.8 1.4 1.4m8.8 8.8 1.4 1.4m-11.6 0 1.4-1.4m8.8-8.8 1.4-1.4"
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "theme-light"}) } }